import React from 'react';
import { Fees } from '../../../../api/api-fees';
import * as types from '../constants/action-types';
import { get } from 'lodash';
import { FormattedMessage } from 'react-intl';

const errorComponent = <FormattedMessage id="hosting.space.error_message" defaultMessage="Something went wrong. Please try again." />;

export function createBillingRequest (isPosting) {
  return {
    type: types.BILLING_CREATE_REQUEST,
    isPosting
  };
}

export function createBillingSuccess (data) {
  return {
    type: types.BILLING_CREATE_SUCCESS,
    data
  };
}

export function createBillingFailure (postError) {
  return {
    type: types.BILLING_CREATE_FAILURE,
    postError
  };
}

export function createVatRequest (isPosting) {
  return {
    type: types.VAT_CREATE_REQUEST,
    isPosting
  };
}

export function createVatSuccess (data) {
  return {
    type: types.VAT_CREATE_SUCCESS,
    isPosting: false,
    data
  };
}

export function createVatFailure (postError) {
  return {
    type: types.VAT_CREATE_FAILURE,
    isPosting: false,
    postError
  };
}

export function fetchAddressByIdRequest (isFetching) {
  return {
    type: types.FETCH_ADDRESS_BY_ID_REQUEST,
    isFetching
  };
}

export function fetchAddressByIdSuccess (data) {
  return {
    type: types.FETCH_ADDRESS_BY_ID_SUCCESS,
    data
  };
}

export function fetchAddressByIdFailure (fetchError) {
  return {
    type: types.FETCH_ADDRESS_BY_ID_FAILURE,
    fetchError
  };
}

export function updateVatProfileRequest (isPosting) {
  return {
    type: types.VAT_UPDATE_REQUEST,
    isPosting
  };
}

export function updateVatProfileSuccess (data) {
  return {
    type: types.VAT_UPDATE_SUCCESS,
    data
  };
}

export function updateVatProfileFailure (updateError) {
  return {
    type: types.VAT_UPDATE_FAILURE,
    updateError
  };
}

export function removeVatProfileRequest (isPosting) {
  return {
    type: types.VAT_REMOVE_REQUEST,
    isPosting
  };
}

export function removeVatProfileSuccess (data) {
  return {
    type: types.VAT_REMOVE_SUCCESS,
    data
  };
}

export function removeVatProfileFailure (updateError) {
  return {
    type: types.VAT_REMOVE_FAILURE,
    updateError
  };
}

export function fetchBillingRequest (isFetching) {
  return {
    type: types.BILLING_FETCH_REQUEST,
    isFetching
  };
}

export function fetchBillingSuccess (data) {
  return {
    type: types.BILLING_FETCH_SUCCESS,
    data
  };
}

export function fetchBillingFailure (fetchError) {
  return {
    type: types.BILLING_FETCH_FAILURE,
    fetchError
  };
}

export function updateBillingRequest (isPosting) {
  return {
    type: types.BILLING_UPDATE_REQUEST,
    isPosting
  };
}

export function updateBillingSuccess (data) {
  return {
    type: types.BILLING_UPDATE_SUCCESS,
    data
  };
}

export function updateBillingFailure (updateError) {
  return {
    type: types.BILLING_UPDATE_FAILURE,
    updateError
  };
}

export function fetchAllFeeProfilesRequest (isFetching) {
  return {
    type: types.FEE_PROFILES_FETCH_REQUEST,
    isFetching
  };
}

export function fetchAllFeeProfilesSuccess (data) {
  return {
    type: types.FEE_PROFILES_FETCH_SUCCESS,
    data
  };
}

export function fetchAllFeeProfilesFailure (fetchError) {
  return {
    type: types.FEE_PROFILES_FETCH_FAILURE,
    fetchError
  };
}

export function createBillingAddress (accessToken, ssoId, payload) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(createBillingRequest(true));

      Fees.createAddress(accessToken, ssoId, payload, response => {
        if (200 === response.statusCode) {
          dispatch(createBillingSuccess(response));

          return resolve(response);
        }
        const errorMessage = get(response, 'error', errorComponent);

        dispatch(createBillingFailure(errorMessage));
        return reject(errorMessage);
      });
    });
  };
}

export function createVatAddress (accessToken, ssoId, payload) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(createVatRequest(true));

      Fees.createVatAddress(accessToken, ssoId, payload, response => {
        if (200 === response.statusCode) {
          dispatch(createVatSuccess(response));

          return resolve(response);
        }

        const errorMessage = get(response, 'error', errorComponent);
        dispatch(createVatFailure(errorMessage));
        return reject(errorMessage);
      });
    });
  };
}

export function fetchAddressById (accessToken, feeProfileId) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchAddressByIdRequest(true));

      Fees.fetchAddressById(accessToken, feeProfileId, response => {
        if (200 === response.statusCode) {
          dispatch(fetchAddressByIdSuccess(response));

          return resolve(response);
        }

        const errorMessage = get(response, 'error', errorComponent);
        dispatch(fetchAddressByIdFailure(errorMessage));
        return reject(errorMessage);
      });
    });
  };
}

export function fetchBillingAddress (accessToken, ssoId) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchBillingRequest(true));

      Fees.fetchAddress(accessToken, ssoId, 'billing', response => {
        if (200 === response.statusCode) {
          dispatch(fetchBillingSuccess(response));

          return resolve(response);
        }

        const errorMessage = get(response, 'error', errorComponent);

        dispatch(fetchBillingFailure(errorMessage));
        return reject(errorMessage);
      });
    });
  };
}

export function updateBillingAddress (accessToken, feeProfileId, payload) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(updateBillingRequest(true));

      Fees.updateAddress(accessToken, feeProfileId, payload, response => {
        if (200 === response.statusCode) {
          dispatch(updateBillingSuccess(response));

          return resolve(response);
        }

        const errorMessage = get(response, 'error', errorComponent);

        dispatch(updateBillingFailure(errorMessage));
        return reject(errorMessage);
      });
    });
  };
}

export function fetchAllFeeProfiles (accessToken, ssoId) {
  // fetches all ACTIVE user's BILLING and VAT addresses
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchAllFeeProfilesRequest(true));

      Fees.fetchAllFeeProfiles(accessToken, ssoId, response => {
        if (200 === response.statusCode) {
          dispatch(fetchAllFeeProfilesSuccess(response));

          return resolve(response);
        }

        const defaultErrMsg = 'Error fetching fee profiles';
        const errorMessage = get(response, 'error', defaultErrMsg);
        dispatch(fetchAllFeeProfilesFailure(errorMessage));

        return reject(errorMessage);
      });
    });
  };
}

export function updateVatProfile (accessToken, ssoId, feeProfileId, payload) {
  //deactivates current vat fee profile and creates a new ACTIVE profile
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(updateVatProfileRequest(true));

      Fees.updateVatAddress(accessToken, ssoId, feeProfileId, payload, response => {
        if (200 === response.statusCode) {
          dispatch(updateVatProfileSuccess(response));

          return resolve(response);
        }

        const defaultErrMsg = 'Error updating vat profile';
        const errorMessage = get(response, 'error', defaultErrMsg);
        dispatch(updateVatProfileFailure(errorMessage));

        return reject(errorMessage);
      });
    });
  }
}

export function removeVatProfile (accessToken, ssoId, feeProfileId) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(removeVatProfileRequest(true));

      Fees.deactivateVatProfile(accessToken, ssoId, feeProfileId, response => {
        if (200 === response.statusCode) {
          dispatch(removeVatProfileSuccess(response));

          return resolve(response);
        }

        const defaultErrMsg = 'Error deactivating vat profile';
        const errorMessage = get(response, 'error', defaultErrMsg);
        dispatch(removeVatProfileFailure(errorMessage));

        return reject(errorMessage);
      });
    });
  }
}
